<script> 
 import { Col, Row, Card, CardBody, CardHeader, Table } from 'sveltestrap';
 import { selectedGroup } from '../store.js';
 import http from '../api/http.js';
 import ManageVesselAttributesModal from '../modals/ManageVesselAttributesModal.svelte';
 import '../css/app.css'
	import { onMount } from 'svelte';

 export let vessel;
 let manageVesselAttributeModal;
 let vessels = [];

 async function setVessels(){
  vessels.push(vessel);
  vessels = vessels;
 }

 async function resetVessels(){
  vessels = [];
  vessels = vessels;
 }

async function getVessel(){
  const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/${vessels[0].id}/${$selectedGroup}`);
  vessel = await res.json();
  resetVessels();
  setVessels();
  vessels = vessels;
}

onMount(async () => {
  await getVessel();
});
</script>

  {#await setVessels()}
    <p>Loading vessel...</p>
  {:then}
    <Row>
        <Col xs="6">
          <Card class="mb-4">
            <CardHeader>
              <h6 class="m-0 font-weight-bold">Vessel Details</h6>
            </CardHeader>
            <CardBody>
              <p><strong>Vessel Name:</strong> {vessels[0].name}</p>
              <p><strong>IMO Number:</strong> {vessels[0].imoNumber}</p>
            </CardBody>
          </Card>
        </Col>
        <Col xs="6">    
          <Card class="mb-4">
            <CardHeader>
              <h6 class="m-0 font-weight-bold">Vessel Account Details</h6>
            </CardHeader>
            <CardBody>                           
              <p><strong>Account:</strong> {vessels[0].account}</p>
              <p><strong>Vessel Email:</strong> {vessels[0].primaryRoute == null || vessels[0].primaryRoute == '' ? 'N/A' : vessels[0].primaryRoute}</p>
            </CardBody>
          </Card>
        </Col>
    </Row>
    <Card class="mb-4">
      <CardHeader>
        <div class="d-flex">
          <h6 class="m-0 font-weight-bold mt-2">Attributes</h6>      
          <button id="manage-attributes-button" class="btn btn-link ml-auto" on:click={() => manageVesselAttributeModal.show(vessels)}>Manage Attributes</button>
        </div>
      </CardHeader>
      <CardBody>
        {#if vessels[0].attributes.length == 0}
          <p>No attributes have been set for this vessel.</p>
          {:else}
            <Table>
              <thead>
                <tr>
                  <th>Attribute Name</th>
                  <th>Attribute Value</th>
                </tr>
              </thead>
              <tbody>
                {#each vessels[0].attributes as attribute}
                  <tr>
                    <td>{attribute.name}</td>
                    <td>{attribute.value}</td>
                  </tr>
                {/each}
              </tbody>
            </Table>
        {/if}
      </CardBody>
    </Card>
  {/await}

  <ManageVesselAttributesModal bind:this={manageVesselAttributeModal} on:vesselAttributesUpdated={() => getVessel()}></ManageVesselAttributesModal>

<style>
    
</style>